import { Outlet, ScrollRestoration } from "react-router-dom";

import { Navbar } from "./Navbar";

import styles from './PrivateFreeLayout.module.css';

export const PrivateFreeLayout = () => {

    return (
        <>
            <ScrollRestoration
                getKey={(location, matches) => {
                    // default behavior
                    return location.key;
                }}
            />
            {/* Navbar */}
            <Navbar />
            {/* Navbar */}
            <div className={"container-fluid d-flex flex-column " + styles.mainContainer}>
                <Outlet />
            </div>
        </>
    )
}
